<template>
  <div class="md-layout">
    <div id="objectHeaderContentHidden" style="display: none;">
      <div><md-icon class="icon-color">{{list.pageIcon}}</md-icon></div>
      <div>
        <h1 class="md-title icon-color">{{ $route.name }}</h1>
      </div>
    </div>

    <div class="md-layout-item">
      <ElasticList :list="list"></ElasticList>
    </div>
  </div>
</template>

<script>
  import ElasticList from "@/components/DynamicForm/ElasticList";

  export default {
    components: {
      ElasticList
    },
    data() {
      return {
        list: {
          hideNewRecordButton: false,
          hideListHeader: true,
          deleteMessageNameFields: ['given_name', 'family_name'],
          editPath: "users",
          pageTitle: "Users",
          pageIcon: "emoji_people",
          listQueryId: "searchUsers",
          deleteQueryId: "deleteUser",
          linkRows: true,
          deleteRelatedRecord: {
            record: [
              { deleteSyncQueryId: "deleteTeamUser", relatedModelItem: 'teams' }
            ]
          },
          columns: {
            // id: { label: "ID", searchable: true, display: true },
            email: { label: "Email", sortable: true, display: true },
            // cogUsername: { label: "Cog User Id", display: true },
            given_name: { label: "First Name", sortable: true, display: true },
            family_name: { label: "Last Name", sortable: true, display: true },
            createdAt: { label: "Created", sortable: true, display: true },
          },
          perPageOptions: [5, 10, 20, 25, 50],
          defaults: {
            sort: 'createdAt',
            sortDir: 'desc',
            perPage: 5,
          },
          fuseSearch: null,
        },
      };
    },
  };
</script>

<style></style>
